import React from "react";
import { useSelector } from "react-redux";
import {
  delivered,
  orderReady,
  ordered,
  outForDelivery,
  inTransit,
} from "../../../assets/icons/";
import moment from "moment-timezone";
import Ordered from "../../SVGS/Ordered";
import OrderReady from "../../SVGS/OrderReady";
import InTransit from "../../SVGS/InTransit";
import Delivered from "../../SVGS/Delivered";
import OutForDelivery from "../../SVGS/OutForDelivery";

const TrackingPreview = ({ order, index, stt }) => {
  const {
    trackingStatus: i18n,
    general: { dateFormat, timeFormat, show },
    time_zone,
  } = useSelector((state) => state.settings);
  const trackingStatus = i18n[order?.tracking_summary];
  let trackingDetails =
    typeof order?.tracking_detail === "string"
      ? JSON.parse(order?.tracking_detail)
      : order?.tracking_detail;
  trackingDetails = trackingDetails?.length
    ? trackingDetails[0]
    : { date_time: "", message: "" };

  const renderIcon = (status) => {
    switch (status) {
      case "pending":
        return <Ordered />;
      case "information_received":
        return <OrderReady />;
      case "in_transit":
        return <InTransit />;
      case "delivered":
        return <Delivered />;
      case "out_for_delivery":
        return <OutForDelivery />;
      default:
        return <Ordered />;
    }
  };

  return (
    <div className="preview-content-tracking">
      <div className="preview-content-tracking-number">
        <div>{renderIcon(order?.tracking_summary)}</div>
        <div>
          <p>{order?.tracking_number}</p>
          <p>{trackingStatus}</p>
        </div>
      </div>
      <div className="preview-content-tracking-company text-center">
        {show.includes("tracking_company") && order?.tracking_company}
      </div>
      <div className="preview-content-tracking-detail">
        <strong>
          {trackingDetails.date_time &&
            moment
              .tz(trackingDetails.date_time, time_zone)
              .format(dateFormat)}{" "}
          {trackingDetails.date_time &&
            moment.tz(trackingDetails.date_time, time_zone).format(timeFormat)}
        </strong>{" "}
        <span>{trackingDetails.message}</span>
      </div>
    </div>
  );
};

export default TrackingPreview;
